"use strict";
var core_1 = require('@angular/core');
var TooltipOptions = (function () {
    function TooltipOptions(options) {
        Object.assign(this, options);
    }
    TooltipOptions.decorators = [
        { type: core_1.Injectable },
    ];
    /** @nocollapse */
    TooltipOptions.ctorParameters = [
        { type: Object, },
    ];
    return TooltipOptions;
}());
exports.TooltipOptions = TooltipOptions;



//////////////////
// WEBPACK FOOTER
// /home/backend/KreditCentr/WebLombard/client/~/ng2-bootstrap/components/tooltip/tooltip-options.class.js
// module id = ../../../../ng2-bootstrap/components/tooltip/tooltip-options.class.js
// module chunks = 3